export default __webpack_public_path__ + "static/web-site-bottom-mobile-52f73555bf080b58df065ded763ab5c4.jpg";